import React, { useEffect, useState, FC } from "react";
import { t } from "i18next";
import { Product } from "interface/common";
import CustomButton, { TextButton } from "ui/Button";
import { handleFilteredItem } from "utils/statUtils";
import GridWithGroupPaging from "ui/grid/GridWithGroupPaging";
import { ICON_NAMES } from "utils/constant";

interface IPage {
	skip: number;
	take: number;
	text: string; // Added text property
}
export const ProductGrid: FC<{
	data: Product[];
	page?: IPage;
	setPage?: (page: IPage) => void;
	headerText: string;
	btnIconName: string;
	btnClick: (product: Product) => void;
	showAllProducts?: boolean;
	hideVirtualScroll?: boolean;
}> = ({
	data,
	page = {
		skip: 0,
		take: 20,
		totalCount: 0,
		isSearched: false,
	},
	setPage,
	btnIconName,
	btnClick,
	headerText,
	showAllProducts = true,
	hideVirtualScroll = false,
}) => {
	const [gridData, setGridData] = useState<Product[]>(data);

	useEffect(() => {
		setGridData(data);
	}, [data]);

	const getData = async (searchText: string = "", take: number) => {
		if (!setPage) return;
		try {
			// const response = await SearchProfileAllProducts(searchText);
			const newPage: IPage = {
				skip: 0,
				take: take,
				text: searchText,
			};
			setPage(newPage);
			// setGridData(response || []);
		} catch (error) {
			console.error("Error searching products:", error);
		}
	};
	const ButtonCell = (props: any) => {
		return (
			<td style={{ textAlign: "center" }}>
				{/* <CustomButton
					label={""}
					onClick={() => btnClick(props.dataItem)}
					iconName={btnIconName}
				/> */}
				<TextButton
					text={""}
					bgStyle={{
						height: "26px",
					}}
					iconName={btnIconName}
					onClick={() => btnClick(props.dataItem)}
				/>
			</td>
		);
	};

	return (
		<div>
			<div
				// className="fontWork22"
				style={{ textAlign: "center", marginBottom: "20px" }}
			>
				{headerText}
			</div>
			<GridWithGroupPaging
				gridData={gridData}
				className={hideVirtualScroll ? "hide-virtual-scroll" : ""}
				filterable={showAllProducts}
				pageable={showAllProducts}
				serverFilter={true}
				itemAboveHeight={170}
				handleStateChange={(state) => {
					if (state.filter) {
						const filters = handleFilteredItem(state.filter);
						const text = filters[0].values[0];
						getData(text, state.take || 20);
					} else {
						getData("", state.take || 20);
					}
				}}
				filterOperators={{
					text: [{ text: "grid.filterContainsOperator", operator: "contains" }],
				}}
				gridColumns={[
					{
						field: "name",
						title: t("Description"),
						filter: "text",
						filterable: showAllProducts,

						// cells: {
						// 	filterCell: CustomSearchFilterCell,
						// },
						// columnMenu: (props) => (
						// 	<GridColumnMenuFilter
						// 		{...props}
						// 		expanded={true}
						// 		filterUI={CustomSearchFilterUI}
						// 	/>
						// ),
					},
					{
						cells: {
							data: ButtonCell,
						},
						title: "",
						width: "100px",
						filterable: false,
					},
				]}
			/>
		</div>
	);
};
